// Az értesítés-MÉLYLINK a PARTNER-felületen — `atlas:{kind}:{id}` → portál-route.
//
// MIÉRT KÜLÖN a belső `ref-to-route.ts`-től: a logikai hivatkozás (`resourceRef`) UGYANAZ mindkét felületen (a
// szerver egy értesítést egyszer ír meg), a CÉL viszont felület-függő — a partner nem juthat `/tickets/$id`-re.
// A `null` NEM hiba: a panel ilyenkor statikus sorként rendereli (nem visz 404-re), pontosan úgy, ahogy a
// belső panel teszi az ismeretlen kindre.
import { parseResourceRef } from '@/features/notifications/ref-to-route';

/** A partner-felületen elérhető mélylink-célok. */
export type PortalNotificationRoute =
  | { to: '/portal/tickets/$id'; params: { id: string } }
  | { to: '/portal/messages'; search: { open?: string } };

export function portalRefToRoute(ref: string | null): PortalNotificationRoute | null {
  const parsed = parseResourceRef(ref);
  if (!parsed) return null;
  switch (parsed.kind) {
    case 'ticket':
      return { to: '/portal/tickets/$id', params: { id: parsed.id } };
    // Az ÜZENET a portál üzenet-lapjára, MEGNYITVA (`?open=`) — a levél gombja is ide visz (#91).
    case 'message':
      return { to: '/portal/messages', search: { open: parsed.id } };
    // A megbeszélés-meghívók a portál Üzenetek lapján élnek (ott nincs megbeszélés-részlet) → a lapra.
    case 'meeting':
      return { to: '/portal/messages', search: {} };
    default:
      // Belső fogalom (ügyfél, eszköz, …) — a partnernek nincs hova vinni. Statikus sor lesz belőle.
      return null;
  }
}
